import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController, LoadingController } from 'ionic-angular';
import { Global } from '../../../global/global';
import { CustomToast } from '../services/custom-toast';
import { SharedService, register, Country, RegisterService } from 'baseline-lib';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the RegisterModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register-modal',
  templateUrl: 'register-modal.html',
})
export class RegisterModalPage {

  alreadyHaveAnOTP : boolean;
  registerClicked : boolean;
  mobileNumber : number;
  createPassword : string;
  confirmPassword : string;
  enterOTP : number;
  public registerComp: register;
  public countryList: Country[];

  countryId : number;
  countryName : string;

  country : Country

  constructor(public navCtrl: NavController, public navParams: NavParams,
    private globalData : Global, private toast: CustomToast,
    public _sharedService : SharedService,public viewCtrl : ViewController,public loadingCtrl : LoadingController
    ,public translate : TranslateService, public _sharedServices : SharedService , public _registerServices : RegisterService ) {
      this.registerComp = new register();

      this.country = new Country();
      //this.countryId = null;
      this.countryId = 1;
  }

  ionViewDidLoad() 
  {
    console.log('ionViewDidLoad RegisterModalPage');
  }

  ngOnInit()
  {
    this.registerComp.vendorId = this._sharedServices._configService.getVendorId();
    this._registerServices.countryListDetails(this.registerComp).subscribe(data => {
      this.countryList = [];
      if (data.data) {
        data.data.forEach(element => {
          var _country = new Country();
          _country.countryData(element);
          this.countryList.push(_country);
        });
      }
    });
    this.registerClicked = false
    this.alreadyHaveAnOTP = false
  }
  

  goBack() 
  {
    this.viewCtrl.dismiss();
  }

  register()
  {

    const loader = this.loadingCtrl.create({
      content: "Please Wait",
    });

    // var passwordPattern = new RegExp(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[$@$!%*#?&])[A-Za-z\d$@$!%*#?&]{8,}$/);;
    // var checkPassword = passwordPattern.test(this.createPassword)

    if(this.mobileNumber != null)
    {
      var number = this.mobileNumber.toString()
    }

    if(!this.mobileNumber)
    {
      this.toast.showError("Mobile Number Is Compulsory");
    }
    else if(number.length < 8)  //else if(number.length < 10)
    {
      this.translate.get('Please enter valid phone number').subscribe( //this.translate.get('Please enter valid 10 digit phone number').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
      return false;
    }
    // else if(!checkPassword)
    // {
    //   this.translate.get('Please enter more than 8 char password (Including 1 special char, 1 capital letter, 1 small letter, 1 Number)').subscribe(
    //     value => 
    //     {
    //       this.toast.showError(value);
    //     });
    //   return false;
    // }
    else if(!this.countryId)
    {
      this.toast.showError("Please enter country code")
    }
    else
    {
      loader.present();
      this.registerComp.countryId = this.countryId;
      this.registerComp.mobileNumber = this.mobileNumber;
      this.registerComp.password = this.createPassword;

      this.country = this.countryList.find(x => x.countryId == this.countryId);

      this._registerServices.registerDetails(this.registerComp).subscribe(
        data => {
          loader.dismiss()
          console.log(data);
          if (data.errorCode == 0 || data.errorCode == undefined || data.errorCode == null) {
            //this._notify.successMsg = data.message;
            this.toast.showSuccess(data.message);
            this.viewCtrl.dismiss();

            // this.registerClicked = true
          }
          else {
            this.toast.showError(data.message);
          }
        }, error => {
          loader.dismiss()
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
          }
        });
    }
  }

  alreadyOTPClicked()
  {
    this.alreadyHaveAnOTP = true
    this.countryId = null
    this.mobileNumber = null
  }

  verifyOTP()
  {
    if(this.mobileNumber != null)
    {
      var number = this.mobileNumber.toString()
    }

    if(!this.countryId)
    {
      this.toast.showError("Please enter country code")
    }
    else if(!this.mobileNumber)
    {
      this.toast.showError("Mobile Number Is Compulsory");
    }
    else if(number.length < 10)
    {
      this.translate.get('Please enter valid 10 digit phone number').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
      return false;
    }
    else if(!this.enterOTP)
    {
      this.toast.showError("OTP Cannot Be Empty");
    }
    else
    {

      const loader = this.loadingCtrl.create({
        content: "Please Wait",
      });

      this.registerComp.countryId = this.countryId;
      this.registerComp.mobileNumber = this.mobileNumber;
      this.registerComp.otp = this.enterOTP;

      this._registerServices.registerVerifyDetails(this.registerComp).subscribe(
        data => {
          loader.dismiss()
          console.log(data);
          if (data.errorCode == 0 || data.errorCode == undefined || data.errorCode == null) {
            //this._notify.successMsg = data.message;
            this.toast.showSuccess(data.message);
            this.viewCtrl.dismiss();
          }
          else {
            this.toast.showError(data.message);
          }
        }, error => {
          loader.dismiss()
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
          }
        });
    }
  }

  resendOTP()
  {
    if(this.mobileNumber != null)
    {
      var number = this.mobileNumber.toString()
    }

    if(!this.countryId)
    {
      this.toast.showError("Please enter country code")
    }
    else if(!this.mobileNumber)
    {
      this.toast.showError("Mobile Number Is Compulsory");
    }
    else if(number.length < 10)
    {
      this.translate.get('Please enter valid 10 digit phone number').subscribe(
        value => 
        {
          this.toast.showError(value);
        });
      return false;
    }
    // else if(!this.enterOTP)
    // {
    //   this.toast.showError("OTP Cannot Be Empty");
    // }
    else
    {

      const loader = this.loadingCtrl.create({
        content: "Please Wait",
      });

      this.registerComp.mobileNumber = this.mobileNumber;
      this.registerComp.countryId = this.countryId;

      this._registerServices.resendOtpForRegisteration(this.registerComp).subscribe(
        data => {
          loader.dismiss()
          console.log(data);
          if (data.errorCode == 0 || data.errorCode == undefined || data.errorCode == null) {
            //this._notify.successMsg = data.message;
            this.toast.showSuccess(data.message);
            this.enterOTP = null
          }
          else {
            this.toast.showError(data.message);
          }
        }, error => {
          loader.dismiss()
          if (error.msg) {
            this.toast.showError(error.msg);
          }
          else {
            this.toast.showError(error.message);
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/register-modal/register-modal.ts